import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { useImpersonation } from "../contexts/ImpersonationContext";
import { sendVerificationEmail } from "../services/ledgerService";

// EmailVerificationBanner is a persistent (non-dismissible) prompt shown on every
// authenticated page until the user verifies their email. It reads the current
// user from the app-wide /api/me fetch in ImpersonationContext.
const EmailVerificationBanner = () => {
    const { me } = useImpersonation();
    const [sent, setSent] = useState(false);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(false);

    const user = me?.user;
    if (!user || user.emailVerified) return null;

    const resend = async () => {
        setSending(true);
        setError(false);
        try {
            await sendVerificationEmail();
            setSent(true);
        } catch {
            setError(true);
        } finally {
            setSending(false);
        }
    };

    return (
        <div
            style={{
                background: "#fff3cd",
                color: "#664d03",
                padding: "0.5rem 1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ffe69c",
                gap: "0.75rem",
                flexWrap: "wrap",
            }}
        >
            <span>
                Please verify your email address ({user.email}) to secure your account.{" "}
                {sent
                    ? "Verification email sent — check your inbox."
                    : error
                        ? "Couldn't send the email; please try again."
                        : null}
            </span>
            <span style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                {!sent && (
                    <Button size="sm" variant="warning" onClick={resend} disabled={sending}>
                        {sending ? "Sending…" : "Resend verification email"}
                    </Button>
                )}
                <Link to="/profile" style={{ color: "#664d03", fontWeight: 600 }}>
                    Profile
                </Link>
            </span>
        </div>
    );
};

export default EmailVerificationBanner;
